import { Inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IHttpClientService } from '../../../interfaces/index';
import { GetConfig } from 'src/app/library-modules/auth-config.module';
import { UserMenuResponseModel } from 'src/app/models';

@Injectable()
export class GetUserMenuUseCase {
    constructor(@Inject('IHttpClientService') private httpService: IHttpClientService) { }

    execute(): Observable<UserMenuResponseModel[]> {
        return this.httpService.get(GetConfig().serviceRootUrl+'/api/Authorization/userMenu', new HttpParams());
    }
}
